import { TScreening, TSubmittedField } from './types'

export const COMPETITOR_BAD_ACTOR_REVIEW_FORM = 'competitor_bad_actor_review_form'
export const SCREENING_PARAMETER = 'Screening'

export const SUBMITTED_FIELDS: readonly TSubmittedField[] = [
  'legalName',
  'tradingName',
  'country',
  'address',
  'city',
  'postalCode',
  'state',
  'taxId',
  'website',
  'requestorEmail',
  'generalManagerEmail',
  'companyEmail',
  'partnerId',
]

const SCREENINGS: readonly TScreening[] = ['competitors', 'bad-actors']
const LARGEST_REQUEST_ID = 2147483647

const isScreening = (value: string): value is TScreening =>
  SCREENINGS.some((screening) => screening === value)

const screeningParameterOf = (parameters: unknown): unknown =>
  typeof parameters === 'object' && parameters !== null && SCREENING_PARAMETER in parameters
    ? parameters[SCREENING_PARAMETER]
    : undefined

export const screeningOfParameters = (parameters: unknown): TScreening | null => {
  const configured = screeningParameterOf(parameters)

  if (typeof configured !== 'string') {
    return null
  }

  const screening = configured.trim().toLowerCase()

  return isScreening(screening) ? screening : null
}

export const configuredScreeningValue = (parameters: unknown): string | null => {
  const configured = screeningParameterOf(parameters)

  return configured === undefined || configured === null ? null : JSON.stringify(configured)
}

export const isRequestId = (requestId: number): boolean =>
  Number.isInteger(requestId) && requestId >= 1 && requestId <= LARGEST_REQUEST_ID

export const displayedText = (value: unknown, noValue: string): string =>
  typeof value === 'string' && value.trim() !== '' ? value : noValue
